import BaseAPI from "api/BaseAPI";

export default class Product extends BaseAPI {
	
	
	getProducts = (page) => {
		let params = {};
		if(page > 0) {
			params["page"] = page;
		}
		return this.init().get("/account/product", {params});
	};

	getProductById = (productId) => {
		if(!productId) {
			productId = 0;
		}
		return this.init().get("/account/product/"+productId, { });
	};
	
	async setProductState(params) {
		try {
			var t = await this.init().post("/account/product/setState", params);
			return t;
		} catch(error) {
			console.log( error );
		}
		return false;
	}

	
	async getProducts2(params) {
		try {
			var t = await this.init().get("/account/product", { params: params });
			return t;
		} catch(error) {
			console.log( error );
		}
		return false;
	}

	async addProduct(productData) {
			let formData = new FormData();
			const params = productData.getData();
			if(!params.is_editable) {
				params.is_editable = 0;
			}
			//const productImages = productData.product_images;
			for ( var key in params ) {
				formData.append(key, params[key]);
			}
			formData.append("company_location_id", productData.product_location.location_id);
			const productImages = [...productData.product_images];
			if(productImages && productImages.length > 0) {
				let photoCounter = 0;
				let newPhotoArray = [];
				for(let i in productImages) {
					newPhotoArray[i] = Object.assign({}, productImages[i]);
					formData.append("file["+photoCounter+'][id]', productImages[i].id);
					formData.append("file["+photoCounter+'][remove]', productImages[i].remove);
					if(productImages[i].file) {
						formData.append("file["+photoCounter+'][file]', productImages[i].file);
						newPhotoArray[i].file = null;
					}
					photoCounter += 1;
				}
					formData.append("productImages", JSON.stringify(newPhotoArray));
				
			}
			var t = await this.init().post("/account/product", formData, {
				headers: {
					"Content-Type": "multipart/form-data",
			}});
			return t;
	}
	
}